const filterRules = [
  // check for rule DATE_WEEKDAY ignore the rule if the sentence says "Il giorno"
  function (match) {
    if (
      match.rule.id === 'DATE_WEEKDAY' &&
      match.context.text.toLowerCase().includes('il giorno')
    ) {
      return false;
    }
    return true;
  },

  // check if an UnknownWord appears just after the word "in" (this most likely is not a typo is a location)
  function (match) {
    if (
      match.type?.typeName === 'UnknownWord' ||
      match.rule?.id === 'MORFOLOGIK_RULE_IT_IT'
    ) {
      // Get the full text from context or sentence
      const fullText = match.sentence || match.context?.text || '';

      // Check if the word appears after " in "
      const wordStart = match.offset;
      const beforeWord = fullText.substring(
        Math.max(0, wordStart - 4),
        wordStart
      );

      // Check if the pattern " in " appears before the unknown word
      if (beforeWord.toLowerCase().endsWith(' in ')) {
        return false; // Filter out this match
      }
    }
    return true;
  },
];

export default function filterSpellCheck(result) {
  const filteredMatches = result.matches.filter((match) => {
    return filterRules.every((rule) => rule(match));
  });

  return {
    ...result,
    matches: filteredMatches,
  };
}
